import { Component, Input, OnInit } from '@angular/core';
import { RouterLink} from '@angular/router';
import { Delivery, StatusButtons } from '../../../../_shared/interfaces';
import { ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule } from '@clr/angular';
import { AlertService, IAlertType, TransportStoreService } from "../../../../_shared/services";
import { DatePipe, NgIf } from "@angular/common";
import {
  ClarityIcons,
  checkCircleIcon,
  exclamationCircleIcon,
  exclamationTriangleIcon,
  infoCircleIcon
} from "@cds/core/icon";

@Component({
  selector: 'app-project-details-transport',
  standalone: true,
  imports: [
    ClrDatagridModule,
    NgIf,
    RouterLink,
    DatePipe,
    ClrIconModule
  ],
  templateUrl: './project-details-transport.component.html',
  styleUrl: './project-details-transport.component.sass'
})
export class ProjectDetailsTransportComponent implements OnInit {

  transport: Delivery[] = [];
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;
  statusText = '';

  @Input() projectID: string = '';

  constructor(
      private transss: TransportStoreService,
      private alertDispatcher: AlertService,
  ) {
    ClarityIcons.addIcons(infoCircleIcon, checkCircleIcon, exclamationCircleIcon, exclamationTriangleIcon)
  }

  ngOnInit(): void {
    this.loading = true;
    this.loadList(this.projectID);
  }

  statusButtons: StatusButtons[] = [
    { state: 'open',      display: 'Offen',               label: 'alert-info',    icon: 'info-circle'},
    { state: 'running',   display: 'In Arbeit',            label: 'alert-info',    icon: 'info-circle'},
    { state: 'waiting',   display: 'Wartet auf Abholung',  label: 'alert-warning', icon: 'exclamation-triangle'},
    { state: 'ontour',    display: 'On Tour',              label: 'alert-danger',  icon: 'exclamation-circle'},
    { state: 'closed',    display: 'Empfang bestätigt',    label: 'alert-success', icon: 'check-circle'},
    { state: 'cancelled', display: 'Storniert',            label: 'alert-danger',  icon: 'times-circle'},
    { state: 'done',      display: 'Empfang bestätigt',    label: 'alert-success', icon: 'check-circle'},
  ];

  private fallbackStatus = { statusLabel: 'alert-info', statusDisplay: 'Unbekannt', statusIcon: 'info-circle' };

  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(projectStatus: string, buttons: StatusButtons[]) {
    return buttons.findIndex(el => el.state === projectStatus)
  };

  getCellStatus(invoiceStatus: string) {
    const statusline = this.findButtonStatus(invoiceStatus, this.statusButtons);
    if (statusline < 0) return this.fallbackStatus;
    return {
      'statusLabel': this.statusButtons[statusline].label,
      'statusDisplay': this.statusButtons[statusline].display,
      'statusIcon': this.statusButtons[statusline].icon
    };
  }

  loadList(projectId: string) {
    this.transss.getTransport(projectId, 0, 0, 'all').subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.alertDispatcher.show({
            message: ' Keine Transportscheine gefunden! ',
            clrAlertType: IAlertType.WARNING
          }, 2000);
          return;
        }
        this.transport = data.object;
      },
      complete: () => {
        this.loading = false;
        this.descSort = ClrDatagridSortOrder.DESC;
      },
      error: () => {
        return
      }
    });
  }

  findButtonClass(invoiceStatus: string) {
    return "alert " + this.getCellStatus(invoiceStatus) + " alert-sm";
  }
}
